<template>
  <cadastro-base
    :salvar="salvarOuEditar"
    :cancelar-cadastro="fechar"
  >
    <template slot="conteudo">
      <b-row>
        <!-- Empresa (select) -->
        <b-col
          cols="12"
          md="6"
        >
          <!-- Espaço para o select de empresa -->
          <empresa-select
            v-model="empresa"
            :disabled="disabledGeral"
          />
        </b-col>

        <!-- Tipo (enum) -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group label="Tipo">
            <b-form-select
              v-model="alvara.tipo"
              :options="tiposAlvara"
              :disabled="disabledGeral"
            />
          </b-form-group>
        </b-col>

        <!-- Número -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group label="Número">
            <b-form-input
              v-model="alvara.numero"
              :disabled="disabledGeral"
            />
          </b-form-group>
        </b-col>

        <!-- Status (enum) -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group label="Status">
            <b-form-select
              v-model="alvara.status"
              :options="statusAlvara"
              :disabled="disabledGeral"
            />
          </b-form-group>
        </b-col>

        <!-- Observações -->
        <b-col cols="12">
          <b-form-group label="Observações">
            <b-textarea
              v-model="alvara.observacoes"
              :disabled="disabledObservacao || disabledGeral"
              style="border-radius: 8px;"
            />
          </b-form-group>
        </b-col>

        <!-- Data de Emissão -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group label="Data de Emissão">
            <b-form-datepicker
              v-model="alvara.dataEmissao"
              :disabled="disabledGeral"
            />
          </b-form-group>
        </b-col>

        <!-- Data de Vencimento -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group label="Data de Vencimento">
            <b-form-datepicker
              v-model="alvara.dataVencimento"
              :disabled="disabledGeral"
            />
          </b-form-group>
        </b-col>

        <!-- Não notificar vencimento -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group>
            <b-form-checkbox
              v-model="alvara.naoNotificarVencimento"
              :disabled="disabledGeral"
            >
              Não notificar vencimento
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
    </template>
  </cadastro-base>
</template>
<style lang="scss" scoped>

</style>
<script>
import apiAlvara from '@/app-modulo/comuns/alvara/shared/services/api'
import apiEmpresa from '@/app-modulo/comuns/empresa/shared/services/api'
import { getUserData, permitidoAcessarRecursoSeNaoAdmin } from '@/auth/utils'

export default {
  name: 'Alvara',
  components: {
    CadastroBase: () => import('@/shared/components/cadastro-base/CadastroBase.vue'),
    EmpresaSelect: () => import('@/shared/components/empresa-select/EmpresaSelect.vue'),
  },
  data() {
    return {
      tiposAlvara: [
        { value: '1', text: 'Funcionamento' },
        { value: '2', text: 'Sanitário' },
        { value: '3', text: 'Corpo de Bombeiros' },
        { value: '4', text: 'Ambiental' },
        { value: '5', text: 'Outros' },
      ],
      statusAlvara: [
        { value: '1', text: 'Ativo' },
        { value: '2', text: 'Inativo' },
        { value: '3', text: 'Vencido' },
        { value: '4', text: 'Em Processo' },
      ],
      alvara: {
        empresaId: null,
        tipo: null,
        numero: '',
        status: null,
        observacoes: '',
        dataEmissao: null,
        dataVencimento: null,
        naoNotificarVencimento: false,
      },
      empresa: null,
      disabled: false,
      disabledInputs: false,
      disabledObservacao: false,
      disabledGeral: false,
      loadingAlvara: false,
      mensagem: 'Carregando...',
    }
  },
  created() {
    this.getAlvara()
    this.disabledCampos()
  },
  methods: {
    getAlvara() {
      const { id } = this.$route.params
      apiAlvara.GetAlvaraById(id)
        .then(payload => {
          this.alvara = payload.data

          apiEmpresa.getEmpresa(this.alvara.empresaId)
            .then(response => {
              this.empresa = response.data
            })
        })
        .catch(() => {
          this.$erro('Erro ao buscar Alvará')
        })
    },
    fechar() {
      if (this.$route.query && this.$route.query.newAba) {
        this.$router.push({ name: 'alvaras' })
      } else {
        this.$router.go(-1)
      }
    },
    salvarOuEditar() {
      this.alvara.empresaId = this.empresa.id
      if (this.$route.path.includes('/novo')) {
        apiAlvara.createAlvara(this.alvara)
          .then(() => {
            this.fechar()
            this.$sucesso('Alvará salvo com sucesso!')
          })
          .catch(() => {
            this.$erro('Ocorreu um erro ao salvar')
          })
      } else {
        apiAlvara.update(this.alvara.id, this.alvara)
          .then(() => {
            this.fechar()
            this.$sucesso('Alvará atualizado com sucesso!')
          })
          .catch(() => {
            this.$erro('Ocorreu um erro ao atualizar')
          })
      }
    },
    disabledCampos() {
      const userData = getUserData()
      const permissaoUpdate = permitidoAcessarRecursoSeNaoAdmin('alvara', 'update')
      if (!userData.admin && !permissaoUpdate) {
        this.disabledObservacao = false
        this.disabledGeral = true
      }
    },
  },
}
</script>
